module.exports = function getResource(label) {
    const resources = { storeDetails: 'Détails du magasin' };

    return resources[label];
};
